module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('h1', {
    staticClass: "chaptitle"
  }, [_c('a', {
    attrs: {
      "id": "page_vii"
    }
  }), _c('a', {
    attrs: {
      "id": "foreword"
    }
  }), _vm._v("FOREWORD")]), _vm._v(" "), _c('p', {
    staticClass: "text"
  }, [_vm._v("In the ancient wisdom teachings of Asia, the monkey is a symbol of a mind that bounces capriciously from one activity to another—restless, wayward, and unsettled. It is this “monkey mind” that Eastern spiritual training exercises, such as meditation, yoga, and mantra chanting, attempt to bring under control.")]), _vm._v(" "), _c('p', {
    staticClass: "textindent"
  }, [_vm._v("“Halfway” expresses the wise approach we must take in dealing with the mind—one that comes with neither too much ambition or too little flexibility; one that doesn't waver with indecision and wishy-washy intentions. “Halfway” is the attitude of perfect balance that remains untouched by the comings and goings of the monkey mind.")]), _vm._v(" "), _c('p', {
    staticClass: "textindent"
  }, [_vm._v("“Meeting” connotes a dynamic effort toward a subject or a goal. It implies an enthusiastic, resolute movement to stabilize the irrepressible mind that cannot retain a moment's peace. This determined effort, applied with diligence and integrity, and directed by wisdom, will enable us to acquire the discipline required to get us on the right track, so that we can “meet the monkey halfway.”")])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-8b4ef1c2","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/04_foreword.vue
// module id = 66
// module chunks = 0